import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { workOrder, workOrderCategory } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { downloadExcel } from "../../utils/exporter";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  getRequestStatusColor,
  getStatusColor,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import ImageViewer from "../../components/ImageViewer";
import Calendar from "../calendar/calendar.js";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { format } from "date-fns";
import WorkOrderKanbanBoard from "./work-order-kanban.js";
import RequestKanbanBoard from "./request-kanban.js";
import CalendarWorkOrder from "./calendar.js";

function WorkOrderList({ isRequest = false }) {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const navigate = useNavigate();
  const [viewType, setViewType] = useState("list");
  const [openPublic, setOpenPublic] = useState(false);
  const [categories, setCategories] = useState([]);
  const [publicToken, setPublicToken] = useState("");
  const [openCustomToken, setOpenCustomToken] = useState(false);
  const [newToken, setNewToken] = useState("");
  const [host, setHost] = useState("");

  async function getData() {
    try {
      const token = await workOrder.getPublicToken();
      if (token.ok) {
        const body = await token.json();
        setPublicToken(body.data);
        setNewToken(body.data);
      }
      setLoading(true);
      const queryParam = {
        ...query,
        isRequest,
      };

      if (viewType == "calendar") {
        delete queryParam.page;
        delete queryParam.take;
      }
      if (viewType == "column") {
        delete queryParam.page;
        delete queryParam.take;
      }

      const res = await workOrder.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }
  const downloadExcelHandler = async () => {
    downloadExcel(datas, "WorkOrder");
  };

  const getCategory = async () => {
    const res = await workOrderCategory.list();
    if (res.ok) {
      const body = await res.json();
      setCategories(body.data);
    }
  };

  function changeOperation(value) {
    openChangeStatus(value);
  }

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">More detail</div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Asset</label>
                      <p>{data.asset?.asset_name}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Category</label>
                      <p>{data.category?.name}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Priority</label>
                      <p>{data.priority}</p>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted By</label>
                      <p>{data.created_by_user?.firstname}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted At</label>
                      <p>
                        {format(new Date(data.created_at), "yyyy-MM-dd hh:mm")}
                      </p>
                    </div>
                  </div>

                  {isRequest && data.request_status !== "Pending" && (
                    <>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>{data.request_status} by</label>
                          <p>{data.action_taken_by_user?.firstname}</p>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>{data.request_status} at</label>
                          <p>
                            {format(
                              new Date(data.action_taken_date),
                              "yyyy-MM-dd hh:mm"
                            )}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() =>
                    !isRequest
                      ? navigate("/work-order/detail/" + data.id)
                      : navigate("/request/detail/" + data.id)
                  }
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>

                {isRequest && data.request_status == "Approved" && (
                  <button
                    style={{ marginRight: "10px" }}
                    onClick={() => navigate("/work-order/detail/" + data.id)}
                    type="button"
                    className="btn btn-outline-primary"
                  >
                    View Work Order
                  </button>
                )}

                {!isRequest && (
                  <>
                    <button
                      onClick={() => navigate("/work-order/edit/" + data.id)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-warning"
                    >
                      <i className="fa fa-edit"></i> Edit{" "}
                      {isRequest ? "Request" : "Work Order"}
                    </button>

                    <button
                      onClick={() => showConfirmationDlg(data)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-danger"
                    >
                      <i className="fa fa-edit"></i> Delete{" "}
                      {isRequest ? "Request" : "Work Order"}
                    </button>
                  </>
                )}

                {isRequest && data.request_status == "Pending" && (
                  <>
                    <button
                      onClick={() => navigate("/request/edit/" + data.id)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-warning"
                    >
                      <i className="fa fa-edit"></i> Edit{" "}
                      {isRequest ? "Request" : "Work Order"}
                    </button>

                    <button
                      onClick={() => showConfirmationDlg(data)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-danger"
                    >
                      <i className="fa fa-trash"></i> Delete{" "}
                      {isRequest ? "Request" : "Work Order"}
                    </button>
                  </>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  async function deleteData() {
    try {
      const response = await workOrder.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success(
            `This ${
              deleteRow.is_request ? "request" : "work order"
            } has been deleted`
          );

          setDeleteRow(null);
          await getData();
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function openChangeStatus(value) {
    setChangeStatus(value);
  }

  function hideChangeStatus() {
    setChangeStatus(null);
  }

  function countOnlineOffline(machine) {
    let online = 0;
    let offline = 0;
    machine.machine_elements.forEach((cm) => {
      if (
        cm.deployments[0]?.sensor?.sensor_uptime[0]?.on_off_status === "true"
      ) {
        online++;
      } else {
        offline++;
      }
    });
    return { online, offline };
  }

  let columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      minWidth: "150px",
    },

    {
      name: "Category",
      selector: (row) => row.category?.name,
    },
    {
      name: "Asset",
      selector: (row) => row.asset?.asset_name,
    },
    {
      name: "Priority",
      selector: (row) => row.priority,
      cell: (row) => (
        <span
          className={`badge border ${
            row.priority === "high"
              ? "border-danger text-danger"
              : row.priority === "medium"
              ? "border-warning text-warning"
              : "border-success text-success"
          }`}
          style={{ textTransform: "capitalize" }}
        >
          {row.priority}
        </span>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={`badge border border-${getStatusColor(
            row.status
          )} text-${getStatusColor(row.status)}`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Start Date",
      selector: (row) => row.start_date,
      cell: (row) => formatDateOnly(row.start_date),
    },
    {
      name: "Due Date",
      selector: (row) => row.due_date,
      cell: (row) => formatDateOnly(row.due_date),
    },
    {
      name: "Submitted By",
      selector: (row) => row.created_by_user?.firstname,
    },
    {
      name: "Submitted At",
      selector: (row) => row.created_at,
      cell: (row) => formatDateOnly(row.created_at),
    },
  ];

  if (isRequest) {
    columns = columns.filter(
      (c) => !["Priority", "Start Date", "Due Date"].includes(c.name)
    );
    columns.splice(3, 0, {
      name: "Request Status",
      selector: (row) => row.request_status,
      cell: (row) => (
        <span
          className={`badge border border-${getRequestStatusColor(
            row.request_status
          )} text-${getRequestStatusColor(row.request_status)}`}
        >
          {row.request_status}
        </span>
      ),
    });

    columns.push({
      name: "Approved by",
      selector: (row) =>
        row.request_status == "Approved"
          ? row.action_taken_by_user?.firstname
          : "-",
    });
    columns.push({
      name: "Approved at",
      selector: (row) =>
        row.request_status == "Approved"
          ? formatDateOnly(row.action_taken_date)
          : "-",
    });

    columns.push({
      name: "Declined by",
      selector: (row) =>
        row.request_status == "Declined"
          ? row.action_taken_by_user?.firstname
          : "-",
    });
    columns.push({
      name: "Declined at",
      selector: (row) =>
        row.request_status == "Declined"
          ? formatDateOnly(row.action_taken_date)
          : "-",
    });
  }

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeCategory = (id) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      category_id: id,
    }));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page, query.take, query.location_id, query.category_id]);
  useEffect(() => {
    getData();
    setViewType("list");
    // eslint-disable-next-line
  }, [isRequest]);

  useEffect(() => {
    if (viewType !== "calendar") {
      getData();
    }

    // eslint-disable-next-line
  }, [viewType]);

  useEffect(() => {
    getCategory();
    const origin = window.location.origin;
    setHost(origin);
  }, []);

  const copyClipboard = () => {
    const host = window.location.origin;
    navigator.clipboard.writeText(`${host}/public-request/${publicToken}`);
    toast.success("Link Copied to clipboard");
  };

  const submitNewToken = async () => {
    try {
      const res = await workOrder.setNewPublicToken(newToken);
      if (res.ok) {
        const body = await res.json();
        setPublicToken(body.data);
        toast.success("New token update successfully");

        setOpenCustomToken(false);
      } else {
        const body = await res.json();
        toast.error(body.message);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      getData();
    }
  };

  return (
    <div className="container">
      <ConfirmationDlg
        title={"Create Custom URL"}
        open={openCustomToken}
        btnSubmitText={"Update"}
        btnCancelText={"Cancel"}
        onClose={() => setOpenCustomToken(false)}
        onSubmit={submitNewToken}
      >
        <p>{host}/request-public/</p>
        <input
          type="text"
          onChange={(e) => setNewToken(e.target.value)}
          value={newToken}
          className={"form-control border border-1 border-theme"}
        />
        <div className="alert alert-info justify-content-between mt-2">
          Your new token will be:
          <hr />
          <small>
            {host}/request-public/{newToken}
          </small>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        title={"Public URL"}
        open={openPublic}
        onClose={() => setOpenPublic(false)}
        onSubmit={() => setOpenPublic(false)}
      >
        <p>This is the public URL to create a Request :</p>
        <div class="alert alert-info d-flex justify-content-between">
          <div>
            {host}/request-public/{publicToken}
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <button className="btn btn-info" onClick={copyClipboard}>
            <i className="fa fa-copy"></i> Copy Link
          </button>

          <button
            className="btn btn-primary"
            onClick={() => {
              setOpenCustomToken(true);
              setOpenPublic(false);
              setNewToken(publicToken);
            }}
          >
            <i className="fa fa-edit"></i> Create Custom URL Link
          </button>
        </div>
      </ConfirmationDlg>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">{isRequest ? "REQUEST" : "WORK ORDER"}</a>
            </li>
            <li className="breadcrumb-item active"> LIST</li>
          </ul>

          <h1 className="page-header">
            {isRequest ? "Request" : "Work Order"} List
          </h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
              <div class="col-sm-3 d-flex justify-content-between">
                <div
                  className="  mb-2 mb-sm-0 btn-group"
                  role="group"
                  aria-label="Basic example"
                  style={{ marginRight: 10 }}
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>List View</Tooltip>}
                  >
                    <button
                      onClick={() => setViewType("list")}
                      type="button"
                      className={`btn ${
                        viewType == "list" ? "btn-theme" : "btn-outline-theme"
                      }`}
                    >
                      <i className="bi bi-list"></i>
                    </button>
                  </OverlayTrigger>

                  {!isRequest && (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Calendar View</Tooltip>}
                    >
                      <button
                        onClick={() => setViewType("calendar")}
                        type="button"
                        className={`btn ${
                          viewType == "calendar"
                            ? "btn-theme"
                            : "btn-outline-theme"
                        }`}
                      >
                        <i className="bi bi-calendar"></i>
                      </button>
                    </OverlayTrigger>
                  )}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Column View</Tooltip>}
                  >
                    <button
                      onClick={() => setViewType("column")}
                      type="button"
                      className={`btn ${
                        viewType == "column" ? "btn-theme" : "btn-outline-theme"
                      }`}
                    >
                      <i className="bi bi-kanban"></i>
                    </button>
                  </OverlayTrigger>
                </div>
                <button
                  onClick={downloadExcelHandler}
                  type="button"
                  className={`btn  btn-outline-theme`}
                >
                  <i className="fa fa-file-excel"></i> Download
                </button>
              </div>

              <div className="col-sm-3 mb-2 mb-sm-0">
                <LocationFilter onChange={handleChangeLocationFilter} />
              </div>
              <div className="col-sm-2 mb-2 mb-sm-0">
                <select
                  className="form-select btn btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeCategory(e.target.value);
                  }}
                >
                  <option value="">
                    - {isRequest ? "Request" : "Work Order"} Category -
                  </option>
                  {categories.map((c, i) => (
                    <option value={c.id}>{c.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-sm-4 mb-2 mb-sm-0">
                <div class="row">
                  <div class={isRequest ? "col-sm-7" : "col-sm-12"}>
                    <button
                      onClick={() => {
                        !isRequest
                          ? navigate("/work-order/add")
                          : navigate("/request/add");
                      }}
                      className="btn btn-outline-theme w-100"
                    >
                      <i className="bi bi-plus"></i>
                      Add {isRequest ? "Request" : "Work Order"}{" "}
                    </button>
                  </div>
                  {isRequest && (
                    <div class="col-sm-5">
                      <button
                        onClick={() => {
                          setOpenPublic(true);
                        }}
                        className="btn btn-outline-theme w-100"
                      >
                        <i className="fa fa-link"></i>
                        Share Link
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {viewType == "list" && (
              <div className="row">
                <div className="col-md-12">
                  <Card>
                    <CardBody>
                      <DataTable
                        progressPending={loading}
                        pointerOnHover
                        highlightOnHover
                        expandOnRowClicked
                        expandableRowsHideExpander
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        onChangeRowsPerPage={(row) =>
                          setQuery((prev) => ({ ...prev, page: 1, take: row }))
                        }
                        paginationTotalRows={query.totalData}
                        onChangePage={(page) =>
                          setQuery((prev) => ({ ...prev, page: page }))
                        }
                      />
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}

            {viewType == "calendar" && <CalendarWorkOrder />}

            {viewType == "column" && !isRequest && (
              <WorkOrderKanbanBoard datas={datas} />
            )}
            {viewType == "column" && isRequest && (
              <RequestKanbanBoard datas={datas} />
            )}
          </div>
        </div>
      </div>

      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Work Order"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteData}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this work order{" "}
            <strong>{deleteRow.title}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
    </div>
  );
}

export default WorkOrderList;
